module.exports = __webpack_public_path__ + "1.4.15-unryo/img/online-analytic-1.89dcd7a4.svg";